import TimesIcon from "@/assets/colorable/times.svg?react";
import Button from "@/components/Common/Button";
import InputField from "@/components/Common/forms/InputField";
import Modal from "@/components/Common/Modal";
import {isInvalidCompanyUrlModalOpenAtom} from "@/store/jotaiAtoms";
import {useOnboardingStore} from "@/store/onboarding";
import {useNavigate} from "@tanstack/react-router";
import {useSetAtom} from "jotai";
import {useState, type FC} from "react";
import {useTranslation} from "react-i18next";
import {useKeyPressEvent} from "react-use";
import LiaAvatar from "/onboarding/lia.png";

const InvalidCompanyUrlModal: FC = () => {
  const {t} = useTranslation(["getting_started", "common"]);
  const navigate = useNavigate();
  const setInvalidCompanyUrlModalOpen = useSetAtom(isInvalidCompanyUrlModalOpenAtom);
  const onClose = () => {
    setInvalidCompanyUrlModalOpen(false);
  };
  const resetForm = useOnboardingStore(state => state.resetForm);
  const [domain, setDomain] = useState("");

  const handleRetry = () => {
    if (!domain) return;
    resetForm();
    window.location.href = `/onboarding/?domain=${domain}`;
  };

  useKeyPressEvent("Escape", onClose);
  useKeyPressEvent("Enter", handleRetry);

  return (
    <Modal
      backgroundClassName="rounded-2.5xl p-5 max-w-150"
      className="my-5 p-0"
      onClose={onClose}
      shouldHideCloseButton
      shouldHideBottomSeparator
      shouldHideHeaderSeparator
      customBottomRow={
        <Button
          onClick={() => {
            setInvalidCompanyUrlModalOpen(false);
            navigate({to: "/register"});
          }}
          buttonStyle="Gradient"
          dataTestId="onboarding-error-manual-register-button"
          className="w-full">
          {t("create_without_url")}
        </Button>
      }
      customTitleRow={
        <div className="relative flex w-full flex-col items-center gap-5">
          <img src={LiaAvatar} className="size-14" />
          <button onClick={onClose} className="absolute top-5 right-0 mr-5 h-fit -translate-y-1/2">
            <TimesIcon className="text-neutral-grey-light hover:text-neutral-grey-dark size-4 transition-colors duration-150" />
          </button>
          <span data-testid="onboarding-error-modal-title" className="text-neutral-black text-xl font-semibold">
            {t("invalid_company_url_title")}
          </span>
        </div>
      }>
      <div className="flex flex-col gap-5 p-0">
        <div className="flex gap-1">
          <InputField
            className="border-neutral-grey-light-dark px-2 text-sm"
            label={t("retry_with_new_url")}
            value={domain}
            onChange={setDomain}
            placeholder={t("url_placeholder")}
            dataTestId="onboarding-error-retry-input"
          />
          <Button
            onClick={handleRetry}
            isDisabled={!domain}
            className="self-end px-8"
            buttonStyle="Gradient"
            dataTestId="onboarding-error-retry-button"
            shouldScaleOnHover={false}>
            {t("retry")}
          </Button>
        </div>
        <div className="text-neutral-grey-dark before:border-primary-light-solid after:border-primary-light-solid flex items-center text-xs before:me-5 before:flex-1 before:border-t after:ms-5 after:flex-1 after:border-t">
          {t("enter_details_manually")}
        </div>
      </div>
    </Modal>
  );
};

export default InvalidCompanyUrlModal;
